import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgSwitcherArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 37" {...props}>
    <path
      fill="#979797"
      d="M0 1v35h2.43a1 1 0 0 0 .913-.593l7.562-16.987L3.347 1.59A1 1 0 0 0 2.435 1H0zm0-1h2.435a2 2 0 0 1 1.824 1.18L12 18.419 4.257 35.813A2 2 0 0 1 2.43 37H0V0z"
    />
  </svg>
);
const Memo = memo(SvgSwitcherArrow);
export default Memo;
